import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { OrderLogResponse } from '@models/order/orderLog';
import { useTranslation } from 'react-i18next';

interface Props {
    order: OrderLogResponse;
}

function Notes({ order }:Props) {
    const { t } = useTranslation('orderLog');
    const {
        paymentAmount, paymentMethod, totalAmount, totalDiscount, status, note,
    } = order;
    const priceUnit = usePriceUnit();
    const isCancelled = status === 'CANCELLED';
    return (
        <Container>
            {note && (
                <Card>
                    <Text size='lg' fontWeight='bold'>{t('notes.requestTitle')}</Text>
                    <Text size='s'>
                        { note}
                    </Text>
                </Card>
            )}
            <Card>
                <Text size='lg' fontWeight='bold'>{t('notes.paymentTitle')}</Text>
                <Grid>
                    <Text color={colors.gray7} as='span'>{t('notes.paymentMethod')}</Text>
                    <Text color={colors.gray7} as='span' align='right'
                        css={isCancelled && canceledCss}>
                        {t(`paymentMethod.${paymentMethod}`)}
                    </Text>
                    <Text color={colors.gray7}>{t('notes.productAmount')}</Text>
                    <Text css={isCancelled && canceledCss} align='right' color={colors.gray7}>
                        {totalAmount.toLocaleString()}{priceUnit}
                    </Text>
                    <Text color={colors.gray7}>{t('notes.discountAmount')}</Text>
                    <Text css={isCancelled && canceledCss} color={colors.gray7} align='right'>
                        -{totalDiscount.toLocaleString()}{priceUnit}
                    </Text>
                    <Divider/>
                    <Text size='lg' fontWeight='bold'>{t('notes.paymentAmount')}</Text>
                    <Text size='2xl' fontWeight='bold' align='right'
                        css={isCancelled && canceledCss}>
                        {paymentAmount.toLocaleString()}{priceUnit}
                    </Text>
                </Grid>
            </Card>
        </Container>
    );
}

const canceledCss = css`
    text-decoration: line-through;
`;

const Divider = styled.div`
    grid-column-start: 1;
    grid-column-end: 3;
    width: 100%;
    height: 1px;
    background-color: ${colors.gray2};
`;

const Container = styled(Column)`
    width: 100%;
    padding-bottom: 24px;
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${colors.gray2};
    margin: 16px 16px 0;
    width: calc(100% - 32px);
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    width: 100%;
    gap: 8px;
`;

export default Notes;
